module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.productTemplate, _vm._b({
    tag: "component"
  }, 'component', _vm.props, false))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-663764c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetailPage.vue
// module id = 1181
// module chunks = 0